module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "access-permission"
  }, [_c('AppHeading', {
    attrs: {
      "level": "2"
    }
  }, [_vm._v("Настройте доступ к своему Портфолио.")]), _vm._v("Вы можете разрешить или запретить видеть информацию из разных разделов своего Портфолио потенциальным работодателям"), _c('div', {
    staticClass: "access-permission_form"
  }, [_c('AppToggle', {
    attrs: {
      "label-text": !_vm.isSelectAllState ? 'Выбрать всё' : 'Снять всё',
      "label-align": "right"
    },
    on: {
      "click": _vm.setSelectedAll
    },
    model: {
      value: (_vm.isSelectAllState),
      callback: function($$v) {
        _vm.isSelectAllState = $$v
      },
      expression: "isSelectAllState"
    }
  }), _c('hr', {
    staticClass: "line-separator"
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к информации об адресе"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_address_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_address_access", $$v)
      },
      expression: "accessPermission.is_address_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к информации о месте учебы"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_study_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_study_access", $$v)
      },
      expression: "accessPermission.is_study_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к информации о месте работы"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_work_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_work_access", $$v)
      },
      expression: "accessPermission.is_work_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к интересующим направлениям"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_directions_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_directions_access", $$v)
      },
      expression: "accessPermission.is_directions_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к результатам обучения в ЦОПП"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_results_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_results_access", $$v)
      },
      expression: "accessPermission.is_results_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к трудоустройству"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_employment_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_employment_access", $$v)
      },
      expression: "accessPermission.is_employment_access"
    }
  }), _c('AppToggle', {
    attrs: {
      "label-text": "Доступ к достижениям"
    },
    on: {
      "input": _vm.toggleInput
    },
    model: {
      value: (_vm.accessPermission.is_achievements_access),
      callback: function($$v) {
        _vm.$set(_vm.accessPermission, "is_achievements_access", $$v)
      },
      expression: "accessPermission.is_achievements_access"
    }
  })], 1), _c('Message', {
    attrs: {
      "accent": _vm.savedData,
      "bottom": true,
      "color": _vm.isError
    }
  }, [_vm._v(_vm._s(_vm.getMessage))]), _c('div', {
    staticClass: "access-permission_btns"
  }, [_c('div', {
    staticClass: "save"
  }, [_c('Button', {
    attrs: {
      "is-loading": _vm.savingData,
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": _vm.savePermissions
    }
  }, [_vm._v("Сохранить изменения")])], 1), _c('div', {
    staticClass: "cancel"
  }, [_c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true,
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Отменить изменения")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cba7a6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/accessPermission/AccessPermission.vue
// module id = 749128936fe01ed54153
// module chunks = 76